import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDmGXH2emlXWPlNTr_EdzUPX0WxgNWSlGI",
  authDomain: "clone-7c8b1.firebaseapp.com",
  databaseURL: "https://clone-7c8b1.firebaseio.com",
  projectId: "clone-7c8b1",
  storageBucket: "clone-7c8b1.appspot.com",
  messagingSenderId: "232926461725",
  appId: "1:232926461725:web:e91b797a73206cc2346bf4",
  measurementId: "G-2N5CHYRP3X",
});

const auth = firebase.auth();

export { auth };
